<template>
  <div id="connect">
    <div class="connect">
      <div class="wx"><img src="../../assets/images/home/erweima.png" class="h-show"><img src="../../assets/images/home/wx.png" class="icon"></div>
      <div class="jf" @click="lianXi=true"><img src="../../assets/images/home/jfTX.png" class="h-show"><img src="../../assets/images/home/jf.png" class="icon"></div>
      <div class="qq"><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=418888265&site=qq&menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:418888265:41" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></div>
    </div>
    <div class="returnTop" @click="gotoTop" transition="bounce" v-show="goTopStatus == 1"></div>

    <div class="blackBoard" :class="{active:lianXi}"></div>
    <div class="lianXi" :class="{active:lianXi}">
      <div v-if="viewHistory==1">
        <div class="title">联系我们</div>
        <div class="tip"><span class="red">*</span>号为必填项，详细填写有助于我们的工作人员尽快联系您</div>
        <div class="close" @click="lianXi=false">×</div>
        <form action="" id="myform" name="myform">
          <ul>
            <li>
              <p class="xiang"><span class="red">*</span>如何称呼您</p>
              <div><input type="text" class="name" placeholder="例如：张先生/女士"></div>
            </li>
            <li>
              <p class="xiang"><span class="red">*</span>公司名称</p>
              <div><input type="text" class="company" placeholder="您的机构名称"></div>
            </li>
            <li>
              <p class="xiang"><span class="red">*</span>联系电话</p>
              <div><input type="text" class="phone" placeholder="您的联系方式"></div>
            </li>
            <li>
              <p class="xiang">电子邮箱</p>
              <div><input type="text" class="email" placeholder="您的邮箱地址"></div>
            </li>
            <li class="question">
              <p class="xiang"><span class="red">*</span>需求/问题</p>
              <div><textarea name="" class="content" placeholder="例如：张先生/女士"></textarea></div>
            </li>
          </ul>
          <div class="smt"><input type="button" id="ajaxBtn" value="提交" @click="submt()"></div>
          <div class="history" @click="shistory()"><button>查看历史反馈</button></div>
        </form>
      </div>
      <ul class="fankuilist" v-else-if="viewHistory==2">
        <div class="returnLianXi" @click="viewHistory=1">返回联系我们</div>
        <li v-for="fklist in fklists" @click="viewHisContent(fklist.id)">{{fklist.name}} {{fklist.time}}：“{{fklist.question.substring(0,25)}}{{fklist.question.length>25?'...':''}}”</li>
      </ul>
      <div class="fkContent" v-else>
        <div class="returnLianXi" @click="viewHistory=2">返回历史反馈</div>
        <div class="name">{{fkContent.name}} {{fkContent.time}}</div>
        <div class="question">需求/问题：{{fkContent.question}}</div>
        <div class="reply">反馈：{{fkContent.reply}}</div>
      </div>
    </div>
    <div class="noteBar"></div>
  </div>
</template>
<script>
export default {
    name:'ConnectPart',
    data:function(){
        return {
          lianXi:false,
          goTopStatus: 0,
          _uploadTempDir:"",
          viewHistory: 1,
          fklists: [],
          fkContent: {}
        }
    },
    methods:{
      submt: function(){
        var that = this;
        var ajaxData = {
          company: $("#myform .company").val(),
          question: $("#myform .content").val(),
          email: $("#myform .email").val(),
          name: $("#myform .name").val(),
          phonenum: $("#myform .phone").val(),
          gcms_title: $("#myform .name").val()
        }
        if(ajaxData.company === ""){
          $(".noteBar").html("公司不能为空");
          $(".noteBar").show().delay(2000).fadeOut(1000);
        } else if(ajaxData.name === ""){
          $(".noteBar").html("名称不能为空");
          $(".noteBar").show().delay(2000).fadeOut(1000);
        } else if(ajaxData.phonenum === ""){
          $(".noteBar").html("联系电话不能为空");
          $(".noteBar").show().delay(2000).fadeOut(1000);
        } else if(ajaxData.question === ""){
          $(".noteBar").html("需求问题不能为空");
          $(".noteBar").show().delay(2000).fadeOut(1000);
        } else{
          var ajaxUrl = xdc_app_config.gcms_server+'/content/fankui';
          $.ajax({
              url: ajaxUrl,
              type: 'POST',
              dataType: 'json',
              beforeSend: function(xhr) {
                  xhr.setRequestHeader("Authorization", "jwt " + xdc_app_config.access_token)
              },
              data:ajaxData
          })
          .done(function(data) {
            console.log(data);
              if(data.code == 4){
                $(".noteBar").html("无权限添加内容");
                $(".noteBar").show().delay(2000).fadeOut(1000, function() {
                  // that.lianXi = false;
                });
              }
              if(data.code == 3){
                  // GCMSAPP.C.logout('addArticle');
              }
              if(data.code == 0){
                $(".noteBar").html("提交成功");
                $(".noteBar").show().delay(1000).fadeOut(3000, function() {
                  // that.lianXi = false;
                });
                $("#myform input,#myform textarea").not("#ajaxBtn").val("");
              }else {
                  // GCMSAPP.C.publisher.publish({type:'error',message:data['message']},'noteBar::add');
              }
          })
          .fail(function() {
            $(".noteBar").html("添加内容条目失败");
            $(".noteBar").show().delay(2000).fadeOut(1000, function() {
              // that.lianXi = false;
            });
          });
        }
      },
      generateMixed: function(n){
        var chars = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
        var res = '';
        for(var i = 0;i<n;i++){
            var id = Math.ceil(Math.random()*35);
            res += chars[id];
        }
        return res;
      },
      gotoTop: function() {
          window.scroll(0,0);
          this.goTopStatus = 0;
      },
      shistory: function(){
        var that = this;
        that.fklists = [];
        var fanwei = escape('[1,2,3]');
        var ajaxUrl = xdc_app_config.gcms_server+'/content/fankui?gcms_status='+fanwei+'&uploadpath='+that._uploadTempDir;
        $.ajax({
          url: ajaxUrl,
          type: 'GET',
          dataType: 'json',
          beforeSend: function(xhr) {
              xhr.setRequestHeader("Authorization", "jwt " + xdc_app_config.access_token)
          },
        })
        .done(function(data){
          // console.log(data.data);
          var history = data.data;
          for(var i=0;i<history.length;i++){
            that.searchHistory(history[i].gcms_id);
          }
        })
      },
      searchHistory: function(id){
        var that = this;
        var ajaxUrl = xdc_app_config.gcms_server+'/content/fankui/'+id+'?uploadpath='+that._uploadTempDir;
        $.ajax({
          url: ajaxUrl,
          type: 'GET',
          dataType: 'json',
          beforeSend: function(xhr) {
              xhr.setRequestHeader("Authorization", "jwt " + xdc_app_config.access_token)
          },
        })
        .done(function(data){
          var redata = data.data;
          var rpObj = {
            question: redata.question,
            time: new Date(redata.gcms_create_time).toLocaleString().replace(/:\d{1,2}$/,' '),
            name: redata.name.substring(0,1)+'**',
            reply: redata.reply,
            id: redata.gcms_id
          }
          that.fklists.push(rpObj);
          that.viewHistory = 2;
        })
      },
      viewHisContent: function(id){
        var that = this;
        var hislist = that.fklists;
        that.viewHistory = 3;
        for(var i=0;i<hislist.length;i++){
          if(hislist[i].id === id){
            that.fkContent = hislist[i];
          }
        }
      }
    },
    mounted: function(){
      this._uploadTempDir = this.generateMixed(20);
    }
} 
</script>
<style scoped>
@import "../../assets/styles/connect.css";
</style>




// WEBPACK FOOTER //
// src/pages/components/connect.vue